import KnowledgeIcon1 from "../../assets/images/knowledgeIcon1.svg";
import KnowledgeIcon2 from "../../assets/images/knowledgeIcon2.svg";
import KnowledgeIcon3 from "../../assets/images/knowledgeIcon3.svg";
import KnowledgeIcon4 from "../../assets/images/knowledgeIcon4.svg";

export const cardData = [
  {
    id: 1,
    img: KnowledgeIcon1,
    title: "Host Knowledge Series",
    description:
      "Organize WAAS events and knowledge sessions at your institution",
  },
  {
    id: 2,
    img: KnowledgeIcon2,
    title: "Joint Publications",
    description: "Co-create research outputs with ISBN/DOI recognition",
  },
  {
    id: 3,
    img: KnowledgeIcon3,
    title: "Mentor Network Access",
    description: "Connect with leading experts and thought leaders globally",
  },
  {
    id: 4,
    img: KnowledgeIcon4,
    title: "Recognition & Co-branding",
    description:
      "Gain national and international visibility through partnerships",
  },
];
